// @angular
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LegacyGuard, UsersRoutingModule} from './users-routing.module';
// Components
import {UsersComponent} from './users.component';
import {UserCreateComponent} from './user-create/user-create.component';
import {UserDetailComponent} from './user-detail/user-detail.component';
import {UserListComponent} from './user-list/user-list.component';
import {CreateUserMessageComponent} from './user-create-message/user-create-message.component';
// Pipe
import {MultiSelectOptionPipe} from './multi-select/multi-select-option.pipe';
// Third Party
import {NgbDropdown, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TreeviewModule } from '@laijuthomas/ngx-treeview';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import {UserDetailResolver} from './user-detail/user-detail-resolver.service';
import {UserDetailService} from './services/user-detail.service';
import {UserManagementGuard} from '../shared/user-management.guard';
import {Select2Module} from '../shared/Select2Module';
import {MyProfileGuard} from '../shared/my-profile.guard';
import {TreeviewPipeLocal} from 'app/treeview/treeview-custom.pipe';
import {ProductInformationComponent} from './product-information/product-information.component';
import {EscapeHtmlPipe} from '../pipes/keep-html.pipe';
import {UserActivateWithPasswordComponent} from './user-activate-with-password/user-activate-with-password.component';
import {UserListLegacyComponent} from './user-list-legacy/user-list-legacy.component';
import {LoadParametersGuard} from './guards/LoadParametersGuard';
import {ParametersService} from './services/parameters.service';
import {CenterInContainerDirective} from '../shared/directives/center-in-container.directive';
import {TransactionLogComponent} from './transaction-log/transaction-log.component';
import {TransactionLogDetailComponent} from './transaction-log-detail/transaction-log-detail.component';
import {TransactionLogDetailMoreComponent} from './transaction-log-detail-more/transaction-log-detail-more.component';
import {SharedModule} from '../shared/shared.module';
import {NgSelect2Module} from 'ng-select2';
import {UsersExportDialogComponent} from './users-export/users-export-dialog.component';
import {TwoFctorBulkUpdateDialogComponent} from "./2fa-bulk-update/2fa-bulk-update-dialog.component";
import { UserConversionToFederationConfirmationDialogComponent } from './user-conversion-to-federation-confirmation/user-conversion-to-federation-confirmation-dialog.component';
import {UserListAdminGuard} from "../shared/user-list-admin.guard";
import { EditUsernameDialogComponent } from './edit-username-dialog/edit-username-dialog.component';
import { UsernameValidatorDirective } from './validators/username-validator.directive';
import { UserRemoveDeactivationDateComponent } from './user-remove-deactivation-date/user-remove-deactivation-date.component';
import { PhysicianNppaUserChildComponent } from './physician-nppa-user-child/physician-nppa-user-child.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    TreeviewModule.forRoot(),
    NgxBootstrapMultiselectModule,
    UsersRoutingModule,
    Select2Module,
    SharedModule,
    NgSelect2Module,
    BsDatepickerModule.forRoot(),
    PhysicianNppaUserChildComponent,
  ],
  declarations: [
    UsersComponent,
    UserListComponent,
    UserListLegacyComponent,
    UserCreateComponent,
    CreateUserMessageComponent,
    UserDetailComponent,
    MultiSelectOptionPipe,
    TreeviewPipeLocal,
    ProductInformationComponent,
    EscapeHtmlPipe,
    UserActivateWithPasswordComponent,
    CenterInContainerDirective,
    TransactionLogComponent,
    TransactionLogDetailComponent,
    TransactionLogDetailMoreComponent,
    UsersExportDialogComponent,
    TwoFctorBulkUpdateDialogComponent,
    UserConversionToFederationConfirmationDialogComponent,
    EditUsernameDialogComponent,
    UsernameValidatorDirective,
    UserRemoveDeactivationDateComponent
    ],
  providers: [
    NgbDropdown,
    UserDetailResolver,
    UserDetailService,
    UserManagementGuard,
    UserListAdminGuard,
    MyProfileGuard,
    LegacyGuard, // remove this in a subsequent relase
    ParametersService,
    LoadParametersGuard
  ],
})
export class UsersModule { }
